import { render, staticRenderFns } from "./index.vue?vue&type=template&id=699d2657&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=699d2657&lang=scss&scoped=true&vars=%7B%20height%20%7D"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699d2657",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('699d2657')) {
      api.createRecord('699d2657', component.options)
    } else {
      api.reload('699d2657', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=699d2657&scoped=true", function () {
      api.rerender('699d2657', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BjKeyImage/index.vue"
export default component.exports